import React from 'react';
import styled from 'styled-components';
import { Colors, Layout, Spacing } from '../../constants/theme';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  hasSubHeader?: boolean;
  fullWidth?: boolean;
  paddingTop?: number;
}

const Container = styled.div<{ 
  hasSubHeader: boolean; 
  fullWidth: boolean; 
  paddingTop?: number;
}>`
  background: ${Colors.background};
  min-height: 100vh;
  /* Ensure content doesn't get hidden under sticky header */
  padding-top: ${props => {
    if (props.paddingTop !== undefined) return `${props.paddingTop}px`;
    return props.hasSubHeader 
      ? `${Layout.contentOffsetWithSubHeader}px` 
      : `${Layout.contentOffsetWithHeader}px`;
  }};
  
  ${props => !props.fullWidth && `
    max-width: 1400px;
    margin: 0 auto;
    padding-left: ${Spacing.xl}px;
    padding-right: ${Spacing.xl}px;
    
    @media (max-width: 768px) {
      padding-left: ${Spacing.md}px;
      padding-right: ${Spacing.md}px;
    }
  `}
`;

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className,
  hasSubHeader = false,
  fullWidth = false,
  paddingTop
}) => {
  return (
    <Container 
      className={className}
      hasSubHeader={hasSubHeader}
      fullWidth={fullWidth}
      paddingTop={paddingTop}
    >
      {children}
    </Container>
  );
};

export default PageContainer;